<template>
  <div class="main-background d-flex align-center justify-center">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" align="right">
        <v-card align="left" class="ma-4" maxWidth="600px" height="auto">
        <v-card-title class="text-h6">Bienvenue sur FrigoFix !</v-card-title>
        <v-card-text>FrigoFix est une application web, compatible PC et mobile, qui te permet de gérer facilement ton stock de nourriture et bien plus encore dans le futur!</v-card-text>
        <v-card-actions class="d-flex flex-wrap">
          <v-btn class="center" style="background-color: aliceblue;" @click="goToLogin">J'essaie !</v-btn>
        </v-card-actions>
      </v-card>
      </v-col>
      
      <v-col cols="12" sm="6" align="center"  >
        <img src="../../public/img/Pictures/FrigoFixMainPicture.png" class="img-fluid" />
      </v-col>
      
    </v-row>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

  const router = useRouter();
  
  const goToLogin = () => {
    router.push("/login");
  }

</script>

<style scoped>
.img-fluid {
  max-width: 300px;
  max-height:600px;
  height: auto;
}
.main-background {
  overflow: hidden;
}
</style>
